import FooterComponent from "./Components/FooterComponent";
import HeroComponent from "./Components/HeroComponent";
import MainComponet from "./Components/MainComponet";

import "./App.css";
import "./queries.css";

function App() {
  return (
    <>
      <HeroComponent />
      <MainComponet />
      <FooterComponent />
    </>
  );
}

export default App;
